<template>
	<div class="home">
		<b-container class="bv-example-row" :class="{'top':$route.path=='/'}" style="margin-top: 8px;">
			<b-row class="text-center">
				<b-col class="topLeft clear" md="3" sm="4" cols="3">
					<div class="clear" style="margin-top: -6px;margin-bottom: 2px;">
						<img class="left" src="../assets/search.png" />
						<p @click="showSearch = !showSearch" class="searchP left" style="font-size: 12px;margin-top: -2px;margin-left: 6px;color: #A1A1A1;margin-bottom: 0px;">搜索</p>
						<p class="searchPhone" v-b-modal.modal-prevent-closing>搜索</p>
					</div>
					<b-input-group v-if="showSearch" style="width: 86%;">
						<b-form-input v-model="searchName" style="border-radius: 0px;margin-right: 4px;border: 1px solid #A9A9A9;outline-style: none;"></b-form-input>
						<b-input-group-append>
							<p @click="goSearch()"><img src="../assets/search.png" /></p>
						</b-input-group-append>
					</b-input-group>
					
					<!-- 手机搜索模态框 -->
					<b-modal id="modal-prevent-closing" ref="modal" title="搜索" hide-footer hide-header  @show="resetModal" @hidden="resetModal">
						<form ref="form" @submit.stop.prevent="handleSubmit">
							<b-form-group class="clear" label-for="name-input" invalid-feedback="Name is required">
								<b-form-input class="left" id="name-input" v-model="searchName"  required></b-form-input>
								<b-icon-search class="left" @click="goSearch()"></b-icon-search>
							</b-form-group>
						</form>
					</b-modal>
					<!-- <input class="left" type="text" placeholder="搜索" @keyup.enter="goSimple()" v-model="simpleType" /> -->
					<!-- <b-input class="inputLeft left"></b-input> -->
				</b-col>
				<b-col class="img" md="6" sm="8" cols="7">
					<router-link to="/"><img src="../assets/logo.png" /></router-link>
				</b-col>
				<b-col class="minHide topright clear" md="3" sm="0" xs="0" s>
					<span>
						<router-link to="/findDealer">查找经销商</router-link>
					</span>
					<!-- <input class="right" type="text" placeholder="查找经销商" /> -->
				</b-col>
				<b-navbar-toggle class="toggle toggleOne" target="nav-collapse">
					<b-icon icon="justify" font-scale="1.5"></b-icon>
				</b-navbar-toggle>
			</b-row>
		</b-container>

		<div class="navBar" :class="{'navBarBorder': $route.path!='/'}">
			<div class="navwidth">
				<div class="minWidth">
					<el-menu class="el-menu-demo" mode="horizontal">
						<el-submenu index="1">
							<template slot="title">产品展示</template>
							<div class="show clear">
								<div class="showLeft left">
									<p style="padding-top: 5px;margin-left: 10px;">分类目录</p>
									<ul class="myul" v-for="(current,i) in bdataList">
										<li>
											<div @click="goSimple('simple', current.id,'1',current.name)">{{current.name}}</div>
										</li>
									</ul>
								</div>
								<div class="showRight left">
									<p style="padding-top: 5px;margin-left: 10px;">款式</p>
									<ul class="myul" v-for="(current,i) in sdataList">
										<li>
											<div @click="goSimple('simple', current.name,'2')">{{current.name}}</div>
										</li>
									</ul>
								</div>
							</div>
						</el-submenu>

						<el-menu-item index="2">
							<router-link to="/application">应用</router-link>
						</el-menu-item>

						<!-- <el-submenu index="2">
							<template slot="title">应用</template>
							<div class="show">
								<ul>
									<li>
										<router-link to="/application">酒店应用</router-link>
									</li>
									<li>
										<router-link to="/applicationTwo">会所应用</router-link>
									</li>
								</ul>
							</div>
						</el-submenu> -->

						<el-menu-item index="3">
							<router-link to="/applicationTwo">定制</router-link>
						</el-menu-item>

						<el-submenu index="4">
							<template slot="title">探索与发现</template>
							<!-- <a href="javascript:void(0)">探索与发现</a> -->
							<div class="show borderB">
								<ul>
									<li>
										<router-link to="/industryNews">行业资讯</router-link>
									</li>
									<li>
										<router-link to="/companyNews">公司动态</router-link>
									</li>
									<li>
										<router-link to="/newProduct">新品发布</router-link>
									</li>
								</ul>
							</div>
						</el-submenu>

						<el-submenu index="5">
							<template slot="title">资料下载
								<!-- <a href="javascript:void(0)">资料与下载</a> -->
							</template>
							<div class="show">
								<ul>
									<li>
										<router-link to="/installation">安装说明书</router-link>
									</li>
									<li>
										<router-link to="/clean">保养和清洁</router-link></a>
									</li>
									<li>
										<router-link to="/questions">常见问题</router-link>
									</li>
									<li>
										<router-link to="/picture">画册下载</router-link>
									</li>
								</ul>
							</div>
						</el-submenu>

						<el-submenu index="6">
							<template slot="title">关于我们</template>
							<div class="show">
								<ul>
									<li>
										<router-link to="/aboutUs">公司简介</router-link>
									</li>

									<li>
										<a href="javascript:void(0)" @click="toView('/aboutUs', 'doIt')">工艺流程</a>
										<!-- <router-link to="/aboutUs?go=doIt">工艺流程</router-link> -->
									</li>
								</ul>
							</div>
						</el-submenu>

						<el-submenu index="7">
							<template slot="title">联系</template>
							<div class="show showLast">
								<ul>
									<li>
										<router-link to="/findDealer">寻找经销商</router-link>
									</li>
									<li>
										<router-link to="/contact">联系方式</router-link>
									</li>
								</ul>
							</div>
						</el-submenu>
					</el-menu>
				</div>
			</div>
		</div>

		<div class="navBarMobile">
			<b-navbar class="mobileCol" toggleable="lg" variant="info">
				<b-navbar-brand href="javascrpit:void(0)"></b-navbar-brand>
				<b-collapse id="nav-collapse" is-nav>
					<b-navbar-nav class="ml-auto">
						<b-nav-item-dropdown text="产品展示" right>
							<div v-for="(current,i) in sdataList">
								<b-dropdown-item @click="toView2(current.id,current.name)">{{current.name}}</b-dropdown-item>
							</div>
						</b-nav-item-dropdown>


						<b-nav-item-dropdown text="应用" right>
							<b-dropdown-item to="/application">酒店应用</b-dropdown-item>

						</b-nav-item-dropdown>

						<b-nav-item-dropdown text="定制" right>
							<b-dropdown-item to="/applicationTwo">产品定制</b-dropdown-item>
						</b-nav-item-dropdown>

						<b-nav-item-dropdown text="探索与发现" right>
							<b-dropdown-item to="/industryNews">行业资讯</b-dropdown-item>
							<b-dropdown-item to="/companyNews">公司动态</b-dropdown-item>
							<b-dropdown-item to="/newProduct">新品发布</b-dropdown-item>
						</b-nav-item-dropdown>

						<b-nav-item-dropdown text="资料与下载" right>
							<b-dropdown-item to="/installation">安装说明书</b-dropdown-item>
							<b-dropdown-item to="/clean">保养和清洁</b-dropdown-item>
							<b-dropdown-item to="/questions">常见问题</b-dropdown-item>
							<b-dropdown-item to="/picture">画册下载</b-dropdown-item>
						</b-nav-item-dropdown>

						<b-nav-item-dropdown text="关于我们" right>
							<b-dropdown-item to="/aboutUs">公司简介</b-dropdown-item>
							<b-dropdown-item @click="toView('/aboutUs?go=doIt', 'doIt')">工艺流程</b-dropdown-item>
						</b-nav-item-dropdown>

						<b-nav-item-dropdown text="联系" right>
							<b-dropdown-item to="/findDealer">寻找经销商</b-dropdown-item>
							<b-dropdown-item to="/contact">联系方式</b-dropdown-item>
						</b-nav-item-dropdown>
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
		</div>
		<!-- 
			栅格系统
			尺寸：
				超小 xs <576px, 
				小的 576px <= sm < 768px, 
				一般 768px <= md < 992px, 
				大的 992px <= lg < 1200px, 
				超大 1200px < xl
			全屏：fluid
			等分比例 cols
			使用尺寸
		 -->
	</div>
</template>

<script>
	export default {
		name: "myHeader",
		data() {
			return {
				bdataList: [],
				sdataList: [],
				simpleType: "",
				showSearch: false,
				searchName: "",
				// name: '',
				// nameState: null,
				submittedNames: []
			}
		},
		mounted() {
			window.app = this;
			this.getBigCatalogData();
			this.getSmallCatalogData();
		},
		methods: {
			toView(path, goId) {
				if (this.$route.path != path) {
					// 跳转页面
					this.$router.push({
						path: path,
						query: {
							go: goId
						}
					})
				} else {
					document.querySelector("#" + goId).scrollIntoView(true)
				}
			},

			getBigCatalogData() {
				let that = this;
				that.$axios.get(that.$global.baseURL + '/web/productListCatalog/getCatalogBigData.form').then(res => {
					if (res.data.jsonArray == 'error') {
						uni.showModal({
							title: res.data.errorInfo,
							showCancel: false
						});
					} else {
						that.bdataList = res.data.dataList;
					}
				});
			},
			getSmallCatalogData() {
				let that = this;
				that.$axios.get(that.$global.baseURL + '/web/productListCatalog/getCatalogSmallData.form').then(res => {
					if (res.data.jsonArray == 'error') {
						uni.showModal({
							title: res.data.errorInfo,
							showCancel: false
						});
					} else {
						that.sdataList = res.data.dataList;
					}
				});
			},
			goSimple(path, goId, type,name) {
				let that = this;
				let arr = {
					parentId: "",
					catalogName: "",
					type: type
				}
				if (type == "1") {
					arr.parentId = goId;
					arr.catalogName = name;
				} else {
					arr.parentId = "";
					arr.catalogName = goId;
				}
				if (that.$route.path != path) {
					// 跳转页面
					this.$router.push({
						path: '/simple',
						query: {
							parentId: arr.parentId,
							catalogName: arr.catalogName,
							type:type
						}
					})
				} else {
					document.querySelector("#" + goId).scrollIntoView(true)
				}
			},
			goSearch() {
				let that = this;
				that.$router.push({
					path: "/search",
					query: {
						name: that.searchName
					}
				})
			},
			//添加手机搜索模态框
			checkFormValidity() {
				const valid = this.$refs.form.checkValidity()
				this.nameState = valid
				return valid
			},
			resetModal() {
				this.name = ''
				this.nameState = null
			},
		
			handleSubmit() {
				// Exit when the form isn't valid
				if (!this.checkFormValidity()) {
					return
				}
				// Push the name to submitted names
				this.submittedNames.push(this.name)
				// Hide the modal manually
				this.$nextTick(() => {
					this.$bvModal.hide('modal-prevent-closing')
				})
			},
			toView2(id,name) {
				let that = this;
				this.$router.push({
					path: '/simple',
					query: {
						catalogId: id,
						catalogName : name
					}
				})
			}
			
		}
	};
</script>

<style>
	/* 以下是正式样式 */
	.home {
		width: 100%;
	}

	.top {
		border-bottom: 1px solid #C4C4C4;
	}

	.topLeft {
		margin-top: 35px;
	}

	.home .topLeft img {
		width: 12px;
		height: 12px;
		margin-top: 2px;
	}

	.topLeft input {
		background-color: transparent;
		border: 0;
		outline: none;
		font-size: 12px;
		margin-left: 5px;
		width: 70%;
	}

	.home .img {
		width: 50%;
	}

	.home .img img {
		width: 45%;
	}

	.topright {
		margin-top: 30px;
	}

	.topright span {
		font-size: 12px;
	}

	.topright a {
		color: #595757;
		text-decoration: none;
	}

	.topright .router-link-active:hover {
		color: #595757;
		text-decoration: none;
	}

	.home .container {
		padding-bottom: 30px;
	}



	/* 以下是正常样式 */
	.navBar {
		width: 100%;
		margin: 0 auto;
	}

	.navBarBorder {
		border-top: 1px solid #C4C4C4;
		border-bottom: 1px solid #C4C4C4;
	}

	.navwidth {
		width: 100%;
		margin: 0 auto;
	}

	.minWidth {
		width: 900px;
		margin: 0 auto;
		letter-spacing: 1px;
	}

	.show p {
		font-size: 16px;
		color: #595757;
		font-weight: bold;
		padding-top: 15px;
	}

	.show ul li {
		list-style-type: none;
		font-size: 14px;
		color: #595757;
		padding: 4px 0 4px;
		margin-left: 20px;
	}

	.show .myul li {
		list-style-type: none;
		font-size: 14px;
		color: #595757;
		padding: 4px 0 4px;
		margin-left: 12px;
		cursor: pointer;
	}


	.show ul li a {
		/* color: #909399; */
		color: #303133;
		text-decoration: none;
	}

	.show ul li a:hover {
		/* color: #303133; */
		color: #CCB356;
	}

	.navBar .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
		display: none !important;
	}

	.showRight {
		margin-left: 20px;
	}


	.el-menu-demo {
		width: 75%;
		margin: 0 auto;
	}

	.navBar .el-menu.el-menu--horizontal {
		border: 0 !important;
	}

	.navBar .el-menu--popup-bottom-start {
		margin-left: 18px;
		margin-top: -10px !important;
	}

	.el-menu--horizontal>.el-submenu .el-submenu__title {
		color: #303133;
	}

	.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
		color: #CCB356;
	}

	/**
	 * 头部
	 * *******************************
	 */
	.el-menu--horizontal>.el-submenu {
		border: 2px solid #FFFFFF;
		border-bottom: none;
		border-top: none;
	}

	.el-menu--horizontal .el-menu--popup {
		padding: 0px 0px;
		box-shadow: none;
	}

	.el-menu--horizontal .el-menu--popup .show {
		border: 2px solid #EFEFEF;
		border-top: none;
	}

	.el-menu--horizontal .el-menu--popup .show:before {
		content: "";
		position: absolute;
		right: 0;
		top: -1px;
		width: 49%;
		height: 1px;
		background-color: #EFEFEF
	}

	.el-menu--horizontal .el-menu--popup .showLast:before {
		width: 63%;
	}

	.el-menu--horizontal .el-menu--popup .show.borderB:before {
		content: "";
		position: absolute;
		right: 0;
		top: -1px;
		width: 42%;
		height: 1px;
		background-color: #EFEFEF;
	}


	.el-menu--horizontal>.el-submenu.is-opened {
		border-radius: 3px;
		border: 2px solid #EFEFEF;
		border-bottom: none;
		border-top: none;
		color: #CCB356;
	}

	/* ************** */

	/* .el-menu--horizontal>.el-submenu:hover 
	.el-menu--horizontal>.el-submenu:focus,{
		border-radius: 3px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		border: 1px solid #EFEFEF;
		border-bottom: none;
		border-top: none;
		color: #CCB356;
	} */

	.el-menu--popup-bottom-start {
		margin-top: 0;
	}

	/* 应用  定制 两个单独的样式  */
	.el-menu--horizontal>.el-menu-item {
		color: #303133;
		line-height: 57px;
		transition: 0;
	}

	.el-menu--horizontal>.el-menu-item:hover {
		border-radius: 3px;
		box-shadow: 2px 3px 12px 0 rgba(0, 0, 0, .1);
		color: #CCB356;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border: 0px;
	}



	.navBarMobile {
		display: none;
	}

	.navbar-brand {
		display: none;
	}

	.navBarMobile .navbar {
		padding: 0;
	}

	/* 一级导航 */
	.navBarMobile .navbar-collapse .navbar-nav .nav-item {
		margin-left: 0;
		padding-left: 25px;
		padding-bottom: 0;
		font-size: 17px;
		font-weight: lighter;
		background-color: #FFFFFF;
		border-bottom: 1px solid #ebebeb;
	}

	.navBarMobile .navbar-collapse .navbar-nav .nav-item:first-child {
		border-top: 1px solid #ebebeb;
	}

	/* 二级导航 */

	.navbar-nav .dropdown-menu {
		margin: 0;
		margin-left: -26px;
		border-radius: 0;
		padding: 0;
		border: 0;
	}

	.navBarMobile .navbar-collapse .navbar-nav .nav-item .dropdown-menu li {
		padding-left: 25px;
		background-color: #F8F8F8;
		border-bottom: 1px solid #ebebeb;
		margin-left: 0;
	}

	.dropdown-item.active,
	.dropdown-item:active {
		background-color: #F8F8F8;
	}

	.navBarMobile .navbar-collapse .navbar-nav .nav-item .dropdown-menu li:first-child {
		border-top: 1px solid #ebebeb;
	}

	.navBarMobile .navbar-collapse .navbar-nav .nav-item .dropdown-menu li:last-child {
		border-bottom: none;
	}


	.navBarMobile .navbar-collapse .navbar-nav .nav-item .dropdown-menu li .dropdown-item {
		font-size: 17px;
		font-weight: lighter;
		/* padding-left: 25px; */
		padding: 5px 0;
	}


	.dropdown-toggle::after {
		display: none;
	}



	.toggle {
		display: none;
	}

	.home .toggleOne {
		/* position: fixed; */
		position: absolute;
		top: 25px;
		right: 15px;
		outline: none;
	}

	.home .navBarMobile .mobileCol {
		background-color: #fff !important;
	}


	.searchPhone {
		display: none;
	}
	
	.modal{
		top: 40%;
	}
	
	.form-group{
		margin-top: 1rem;
	}
	
	#name-input{
		width: 90%;
	}
	
	#modal-prevent-closing .b-icon.bi{
		margin-left: 10px;
		margin-top: 10px;
	}

	/* 媒体查询 */
	@media screen and (max-width: 850px) {

		.navBar {
			display: none !important;
		}

		.navBarMobile {
			display: block !important;
			margin-top: -17px;
		}

		.toggle {
			display: block;
		}

		.home .container {
			padding-bottom: 15px;
		}

		.home .img {
			margin-left: -15px;
		}

		.home .img img {
			width: 100%;
		}

		.minHide {
			display: none !important;
		}

		.topLeft input {
			display: none !important;
			/* padding-left: 100px !important; */
		}

		/* .img {
			padding-right: 250px !important;
			width: 160px;
		} */

		.home .bv-example-row {
			border-bottom: 1px solid #C4C4C4 !important;
		}

		.input-group-append {
			display: none;
		}

		.searchP {
			display: none;
		}

		.searchPhone {
			display: block;
			font-size: 12px;
			width: 50px;
			line-height: 16px;
			color: #A1A1A1;
			outline: none;
		}
		

	}

	.home .navBar a {
		/* color: #909399; */
		font-size: 14px;
		color: #303133;
		text-decoration: none;

	}

	.home .navBar a:hover {
		/* color: #303133; */
		color: #CCB356;
	}
</style>
